var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 705.667,
    height: 456.005,
    viewBox: "0 0 705.667 456.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M1792.237,1104.742l-6.5-209.579c0-5.521,4.8-9.993,10.716-9.993h331.789c5.917,0,10.712,4.492,10.712,9.993l-9.744,209.579c0,5.521-4.794,9.993-10.712,9.993H1802.949C1797.036,1114.736,1792.237,1110.264,1792.237,1104.742Z",
    transform: "translate(-1785.74 -885.17)",
    fill: "#e4f1f7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M2179.864,984.338s4.615,46.748,2.63,62.654L2171.1,1167.76h98.38s-5.517-102.913-5.517-110.7-1.634-72.721-1.634-72.721l-15.42-7.792-38.8-.486Z",
    transform: "translate(-2171.1 -976.06)",
    fill: "#007ab3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login-image",
    transform: "translate(-76 -317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_11248",
    "data-name": 11248,
    transform: "translate(11.952 221.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(202.189 95.501)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(35.466)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M1074.437,539.919s-6.58-52.469-33.669-83.629a5.874,5.874,0,0,0-10.282,4.033v.278C1030.9,469.967,1061.258,509.282,1074.437,539.919Z",
    transform: "translate(-1030.484 -454.275)",
    fill: "#9fcfb8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(0 5.461)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M1000.877,566.774s-27.2-65.471-73.164-94.223a6.225,6.225,0,0,0-8.435,1.644c-1.209,1.783-1.742,4.557-.347,8.877C922.648,494.6,973.948,533.149,1000.877,566.774Z",
    transform: "translate(-918.1 -471.579)",
    fill: "#9fcfb8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(64.048 315.923)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M609.845,1096.377s41.9,27.724,36.263,35.2-44.469-34.26-44.469-34.26-47.8,17.553-59.1,31.688c0,0,54.425,13.16,47.116,19.02s-64.568-5.2-64.568-5.2-39.037,27.7-24.3,52.538,33.25,25.8,39.356,22.009,36.847-36.292,40.205-31.407-11.011,33.029-26.509,41.477c0,0,45.879,18.619,61.223-.5s9.752-35.064,19.437-46.706,20.3-16.726,17.95-8.483-22.106,24.688-23.164,40.666-3.2,27.727,15.779,14.495c51.919-36.216,31.678-80.158,31.678-80.158s12.841-48.259-25.082-56.735C651.654,1090,625.735,1087.512,609.845,1096.377Z",
    transform: "translate(-497.466 -1089.685)",
    fill: "#9fcfb8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(137.096 200.194)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M811.639,765.06s13.639,25.638,8.713,27.882-13.141-29.665-13.141-29.665-29.125-4.267-38.76-.2c0,0,24.016,21.69,18.689,22.652s-31.369-20.45-31.369-20.45-27.456,3.3-26.824,19.992,9.793,22.274,13.939,22.021,28.718-8.275,29.084-4.869-14.7,13.74-24.9,13.763c0,0,18.168,22.113,31.243,16.625s14.621-15.126,22.753-18.37,14.924-2.9,11.459.631-18.051,6.466-22.977,14.293-9.272,13.2,4.011,11.711c36.361-4.084,38.185-31.99,38.185-31.99s19.831-20.974,2.9-35.736C834.644,773.35,822.166,764.937,811.639,765.06Z",
    transform: "translate(-728.936 -761.32)",
    fill: "#9fcfb8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(314.491 95.787)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M1285.633,505.525s-.316,50.6,9.114,50.08-3.727-56.41-3.727-56.41,41.493-30.151,59.645-31.672c0,0-19.509,52.907-10.509,50.08s31.874-56.94,31.874-56.94,45.052-17.12,57.562,9.152,2.938,42.288-3.655,45.264-51.017,10.477-48.82,16.022,33.808,9.31,49.546,1.089c0,0-10.14,48.827-34.736,50.925s-34.8-11.506-49.975-9.935-25.379,7.593-17.161,10.26,33.048-4.652,47.022,3.424,24.981,12.866,3.269,21.318c-59.408,23.126-84.828-18.455-84.828-18.455s-47.571-16.319-33.395-52.794C1256.858,536.929,1269.3,513.85,1285.633,505.525Z",
    transform: "translate(-1254.22 -455.181)",
    fill: "#9fcfb8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M2458.122,1588.371s-8.887-10.37-.546-16.956c0,0,6.091-3.689,11.045-3.389,0,0-7.038,11.8-4.762,12.977s6.9-13.715,6.9-13.715,13.864-1.344,18.323.8c0,0-11.853,9.7-9.357,10.275s15.309-8.925,15.309-8.925,12.9,2.209,12.216,10.067-5.134,10.3-7.088,10.1-13.384-4.573-13.633-2.973,6.627,6.832,11.449,7.078c0,0-9.1,10.032-15.148,7.135s-6.561-7.486-10.329-9.205-6.987-1.717-5.431.038,8.375,3.471,10.531,7.258,4.1,6.384-2.165,5.444-16.41-5.52-16.868-10.761Z",
    transform: "translate(-1748.176 -1092.26)",
    fill: "#9fcfb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M2492.921,1607.388s-35.03-1.351-42.783,8.672a25.267,25.267,0,0,1-6.978,9.783l-.821,2.237s6.072-6.4,8.246-6.791C2450.586,1621.3,2447.187,1608.884,2492.921,1607.388Z",
    transform: "translate(-1740.192 -1119.949)",
    fill: "#a2d6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M2427.494,1664.089a22.012,22.012,0,0,0-8.044,15.5l1.366.123s2.4-10.279,6.744-14.3S2427.494,1664.089,2427.494,1664.089Z",
    transform: "translate(-1724.526 -1158.195)",
    fill: "#a2d6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M2256.109,1514.29s14.138-7.918,7.542-18.663c0,0-5.28-6.6-10.935-8.293,0,0,3.017,16.022,0,16.41s-2.073-18.1-2.073-18.1-14.892-7.164-20.737-6.6c0,0,9.237,15.646,6.223,15.271s-13.387-16.211-13.387-16.211-15.268-2.84-17.72,6.22,1.509,13.57,3.787,14.138,16.776.376,16.41,2.263-10.181,4.9-15.646,3.2c0,0,6.031,14.892,13.949,14.138s10.37-5.655,15.271-6.031,8.483.947,6.031,2.263-10.73.432-14.7,3.787-7.164,5.441.189,6.943,20.548.565,23.186-5.09Z",
    transform: "translate(-1577.238 -1031.218)",
    fill: "#8ec7ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M2228.8,1507.66s39.59,12.819,44.112,27.14a30,30,0,0,0,3.787,13.759v2.84s-4.147-9.613-6.409-10.932C2270.274,1540.462,2279.135,1528.018,2228.8,1507.66Z",
    transform: "translate(-1594.041 -1051.735)",
    fill: "#87c4a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M2376.418,1633.467s6.106,9.272,2.625,20.557l-1.578-.423s1.524-12.427-1.669-18.679S2376.418,1633.467,2376.418,1633.467Z",
    transform: "translate(-1693.776 -1136.636)",
    fill: "#87c4a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M2413.286,1454.38s-18.638-10.439-9.941-24.615c0,0,6.943-8.7,14.413-10.932,0,0-3.976,21.122,0,21.617s2.733-23.855,2.733-23.855,19.632-9.442,27.336-8.7c0,0-12.175,20.626-8.205,20.128s17.644-21.371,17.644-21.371,20.128-3.727,23.353,8.205-1.988,17.89-4.97,18.619-22.116.5-21.62,2.982,13.418,6.463,20.626,4.226c0,0-7.953,19.629-18.389,18.619s-13.668-7.454-20.128-7.949-11.181,1.24-7.953,2.982,14.166.568,19.383,5.005,9.442,7.17-.25,9.152-27.083.745-30.564-6.709Z",
    transform: "translate(-1711.92 -987.17)",
    fill: "#9fcfb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M2487.226,1445.69s-52.181,16.9-58.146,35.784a39.627,39.627,0,0,1-4.97,18.14v3.727s5.466-12.674,8.448-14.413C2432.558,1488.928,2420.878,1472.527,2487.226,1445.69Z",
    transform: "translate(-1727.715 -1009.321)",
    fill: "#a2d6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M2413.529,1611.553s-8.047,12.219-3.471,27.1l2.07-.555s-2.01-16.385,2.209-24.615S2413.529,1611.553,2413.529,1611.553Z",
    transform: "translate(-1717.134 -1121.261)",
    fill: "#a2d6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M2358.7,1725.494A36.506,36.506,0,0,0,2395.2,1689H2322.19a36.507,36.507,0,0,0,36.507,36.494Z",
    transform: "translate(-1657.959 -1175.847)",
    fill: "#9fcfb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M2394.613,1800.757H2320.59a4.5,4.5,0,0,1,4.5-4.507h65.01a4.5,4.5,0,0,1,4.5,4.507Z",
    transform: "translate(-1656.864 -1249.251)",
    fill: "#9fcfb8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 75.045,
    height: 1.12,
    transform: "translate(663.028 513.14)",
    fill: "#89c8aa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9090",
    "data-name": 9090,
    transform: "translate(180.293 427.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M2109.308,1109.6H1767.779c-5.917,0-10.712-4.492-10.712-10l-6.5-233.809c0-5.517,4.794-9.993,10.712-9.993h357.746c5.917,0,10.712,4.492,10.712,9.993L2120,1099.6C2120.012,1105.124,2115.213,1109.6,2109.308,1109.6Z",
    transform: "translate(-1674.463 -786.338)",
    fill: "#cfd2e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M2137.64,860.91a9.471,9.471,0,0,1,1.8,5.546l-9.744,233.8c0,5.521-4.8,10-10.712,10H1777.464a11.19,11.19,0,0,1-6.534-2.087,10.936,10.936,0,0,0,8.915,4.447h341.508c5.914,0,10.712-4.492,10.712-10l9.744-233.809A9.756,9.756,0,0,0,2137.64,860.91Z",
    transform: "translate(-1686.509 -789.361)",
    fill: "#a5b5db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M1793.433,1092.153l-6.493-209.579c0-5.517,4.794-9.993,10.712-9.993h331.789c5.917,0,10.716,4.492,10.716,9.993l-9.74,209.579c0,5.521-4.794,10-10.712,10H1804.149C1798.232,1102.15,1793.433,1097.674,1793.433,1092.153Z",
    transform: "translate(-1695.98 -796.265)",
    fill: "#a7b7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M1792.237,1104.742l-6.5-209.579c0-5.521,4.8-9.993,10.716-9.993h331.789c5.917,0,10.712,4.492,10.712,9.993l-9.744,209.579c0,5.521-4.794,9.993-10.712,9.993H1802.949C1797.036,1114.736,1792.237,1110.264,1792.237,1104.742Z",
    transform: "translate(-1695.27 -803.713)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(90.47 81.457)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M1056.77,760.454l12.121-.784v.784Z",
    transform: "translate(-715.67 -530.888)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M984.37,757.668l41.688-2.708v1.923l-12.121.784Z",
    transform: "translate(-672.837 -528.102)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M911.97,754.887l71.255-4.627v1.919l-41.688,2.708Z",
    transform: "translate(-630.004 -525.321)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M839.58,752.1,940.4,745.55v1.924L869.143,752.1Z",
    transform: "translate(-587.177 -522.535)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M767.18,749.32l130.385-8.47v1.919L796.747,749.32Z",
    transform: "translate(-544.344 -519.754)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M694.78,746.533,854.732,736.14v1.923l-130.385,8.47Z",
    transform: "translate(-501.512 -516.968)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M622.38,743.753,811.9,731.44v1.919L651.947,743.753Z",
    transform: "translate(-458.679 -514.187)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M549.99,740.966,769.073,726.73v1.924l-189.52,12.313Z",
    transform: "translate(-415.852 -511.401)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M477.59,738.186,726.24,722.03v1.919L507.157,738.186Z",
    transform: "translate(-373.019 -508.62)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M405.19,735.4,683.407,717.32v1.924L434.757,735.4Z",
    transform: "translate(-330.186 -505.833)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M332.8,732.619l307.78-20v1.919L362.363,732.619Z",
    transform: "translate(-287.359 -503.053)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M260.4,729.838,597.747,707.92v1.919l-307.78,20Z",
    transform: "translate(-244.526 -500.272)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M236.4,727.052l-.082-1.282L583.5,703.21v1.924L246.154,727.052Z",
    transform: "translate(-230.28 -497.486)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M236.143,722.989l-.123-1.911,347.3-22.567v1.919Z",
    transform: "translate(-230.102 -494.705)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M235.837,718.291l-.127-1.915L583.14,693.8v1.924Z",
    transform: "translate(-229.919 -491.919)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M235.533,713.595l-.122-1.911L582.962,689.1v1.919Z",
    transform: "translate(-229.742 -489.138)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M235.227,708.9l-.127-1.911,347.679-22.6v1.923Z",
    transform: "translate(-229.558 -486.352)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M234.923,704.205l-.123-1.915,347.8-22.6v1.919Z",
    transform: "translate(-229.381 -483.571)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M234.617,699.5l-.127-1.911L582.418,674.98V676.9Z",
    transform: "translate(-229.197 -480.784)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M234.313,694.812l-.123-1.915L582.241,670.28V672.2Z",
    transform: "translate(-229.02 -478.004)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M234.007,690.11l-.127-1.911L582.057,665.57v1.923Z",
    transform: "translate(-228.836 -475.217)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M233.7,685.418l-.123-1.915,348.3-22.633v1.919Z",
    transform: "translate(-228.659 -472.437)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M233.4,680.722l-.123-1.911L581.7,656.17v1.919Z",
    transform: "translate(-228.481 -469.656)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M233.1,676.024l-.127-1.915L581.519,651.46v1.924Z",
    transform: "translate(-228.298 -466.87)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M232.793,671.328l-.123-1.911L581.341,646.76v1.919Z",
    transform: "translate(-228.121 -464.089)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M232.487,666.631l-.127-1.915,348.8-22.665v1.924Z",
    transform: "translate(-227.937 -461.303)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M232.183,661.935l-.123-1.911L580.981,637.35v1.919Z",
    transform: "translate(-227.76 -458.522)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M231.877,657.237l-.127-1.915L580.8,632.64v1.924Z",
    transform: "translate(-227.576 -455.736)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M231.573,652.541l-.123-1.911,349.17-22.69v1.919Z",
    transform: "translate(-227.399 -452.955)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M231.273,647.843l-.123-1.915,349.292-22.7v1.924Z",
    transform: "translate(-227.221 -450.168)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M230.967,643.147l-.127-1.911L580.259,618.53v1.919Z",
    transform: "translate(-227.038 -447.388)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M230.662,638.45l-.123-1.915L580.081,613.82v1.924Z",
    transform: "translate(-226.86 -444.601)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M230.357,633.754l-.127-1.911L579.9,609.12v1.919Z",
    transform: "translate(-226.677 -441.821)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M230.053,629.062l-.123-1.915L579.72,604.42v1.919Z",
    transform: "translate(-226.5 -439.04)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M229.747,624.36l-.127-1.911L579.537,599.71v1.923Z",
    transform: "translate(-226.316 -436.254)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M229.443,619.668l-.123-1.915L579.359,595.01v1.919Z",
    transform: "translate(-226.139 -433.473)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M229.137,614.966l-.127-1.911L579.176,590.3v1.924Z",
    transform: "translate(-225.955 -430.687)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M228.833,610.275l-.123-1.911L579,585.6v1.919Z",
    transform: "translate(-225.778 -427.906)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M228.533,605.577l-.123-1.915L578.821,580.89v1.923Z",
    transform: "translate(-225.6 -425.12)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M228.227,600.881l-.127-1.911,350.538-22.78v1.919Z",
    transform: "translate(-225.417 -422.339)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M227.923,596.183l-.123-1.915L578.46,571.48V573.4Z",
    transform: "translate(-225.239 -419.552)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M227.617,591.487l-.127-1.911,350.787-22.8V568.7Z",
    transform: "translate(-225.056 -416.772)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M227.313,586.79l-.122-1.915L578.1,562.07v1.924Z",
    transform: "translate(-224.879 -413.985)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M227.007,582.094l-.127-1.911L577.916,557.37v1.919Z",
    transform: "translate(-224.695 -411.205)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M226.7,577.4l-.123-1.915L577.738,552.67v1.919Z",
    transform: "translate(-224.518 -408.424)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M226.4,572.7l-.127-1.911L577.555,547.96v1.924Z",
    transform: "translate(-224.334 -405.638)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M226.092,568.008l-.122-1.915L577.378,543.26v1.919Z",
    transform: "translate(-224.157 -402.857)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M225.787,563.306l-.127-1.911L577.194,538.55v1.923Z",
    transform: "translate(-223.973 -400.071)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M225.483,558.615l-.123-1.915L577.017,533.85v1.919Z",
    transform: "translate(-223.796 -397.29)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M225.183,553.913,225.06,552,576.839,529.14v1.923Z",
    transform: "translate(-223.618 -394.503)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M224.877,549.221l-.127-1.915L576.656,524.44v1.919Z",
    transform: "translate(-223.435 -391.723)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M224.573,544.519l-.123-1.911L576.478,519.73v1.923Z",
    transform: "translate(-223.258 -388.936)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M224.267,539.827l-.127-1.915L576.295,515.03v1.919Z",
    transform: "translate(-223.074 -386.156)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M223.963,535.125l-.123-1.911L576.117,510.32v1.923Z",
    transform: "translate(-222.897 -383.369)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M223.657,530.433l-.127-1.915,352.4-22.9v1.919Z",
    transform: "translate(-222.713 -380.589)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M223.353,525.738l-.123-1.911L575.757,500.92v1.919Z",
    transform: "translate(-222.536 -377.808)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M223.053,521.04l-.123-1.915L575.579,496.21v1.924Z",
    transform: "translate(-222.358 -375.022)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M222.747,516.344l-.127-1.911L575.4,491.51v1.919Z",
    transform: "translate(-222.175 -372.241)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M222.443,511.646l-.123-1.911,352.9-22.935v1.924Z",
    transform: "translate(-221.997 -369.454)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M222.137,506.954l-.127-1.915L575.035,482.1v1.919Z",
    transform: "translate(-221.814 -366.674)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M221.833,502.253l-.123-1.911L574.857,477.39v1.923Z",
    transform: "translate(-221.636 -363.887)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M221.6,497.561l-.074-1.086v-.833L574.751,472.69v1.919Z",
    transform: "translate(-221.53 -361.107)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M221.53,490.935,574.751,467.98V469.9L221.53,492.855Z",
    transform: "translate(-221.53 -358.32)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M221.53,486.231,574.751,463.28V465.2L221.53,488.155Z",
    transform: "translate(-221.53 -355.54)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M221.53,481.525,574.751,458.57v1.923L221.53,483.445Z",
    transform: "translate(-221.53 -352.753)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M221.53,476.821,574.751,453.87v1.919L221.53,478.745Z",
    transform: "translate(-221.53 -349.973)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M221.53,472.115,574.751,449.16v1.923L221.53,474.035Z",
    transform: "translate(-221.53 -347.186)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M221.53,467.411,574.751,444.46v1.919L221.53,469.335Z",
    transform: "translate(-221.53 -344.405)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M221.53,462.711,574.751,439.76v1.919L221.53,464.631Z",
    transform: "translate(-221.53 -341.625)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M221.53,458.005,574.751,435.05v1.924L221.53,459.925Z",
    transform: "translate(-221.53 -338.838)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M221.53,453.3,574.751,430.35v1.919L221.53,455.225Z",
    transform: "translate(-221.53 -336.058)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M221.53,448.6,574.751,425.64v1.923L221.53,450.515Z",
    transform: "translate(-221.53 -333.271)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M221.53,443.891,574.751,420.94v1.919L221.53,445.815Z",
    transform: "translate(-221.53 -330.491)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M221.53,439.185,574.751,416.23v1.923L221.53,441.1Z",
    transform: "translate(-221.53 -327.704)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M221.53,434.481,574.751,411.53v1.919L221.53,436.4Z",
    transform: "translate(-221.53 -324.924)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M221.53,429.775,574.751,406.82v1.923L221.53,431.695Z",
    transform: "translate(-221.53 -322.137)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M221.53,425.071,574.751,402.12v1.919L221.53,426.995Z",
    transform: "translate(-221.53 -319.357)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M221.53,420.365,574.751,397.41v1.924L221.53,422.285Z",
    transform: "translate(-221.53 -316.57)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M221.53,415.661,574.751,392.71v1.919L221.53,417.585Z",
    transform: "translate(-221.53 -313.789)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M221.53,410.961,574.751,388.01v1.919L221.53,412.881Z",
    transform: "translate(-221.53 -311.009)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M221.53,406.255,574.751,383.3v1.924L221.53,408.175Z",
    transform: "translate(-221.53 -308.222)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M221.53,401.551,574.751,378.6v1.919L221.53,403.475Z",
    transform: "translate(-221.53 -305.442)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M221.53,396.845,574.751,373.89v1.923L221.53,398.765Z",
    transform: "translate(-221.53 -302.655)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M221.53,392.141,574.751,369.19v1.919L221.53,394.065Z",
    transform: "translate(-221.53 -299.875)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M221.53,387.435,574.751,364.48V366.4L221.53,389.355Z",
    transform: "translate(-221.53 -297.088)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M221.53,382.731,574.751,359.78V361.7L221.53,384.655Z",
    transform: "translate(-221.53 -294.308)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M221.53,378.025,574.751,355.07v1.923L221.53,379.945Z",
    transform: "translate(-221.53 -291.521)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M221.53,373.321,574.751,350.37v1.919L221.53,375.245Z",
    transform: "translate(-221.53 -288.741)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M221.53,368.615,574.751,345.66v1.924L221.53,370.535Z",
    transform: "translate(-221.53 -285.954)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M221.53,363.911,574.751,340.96v1.919L221.53,365.835Z",
    transform: "translate(-221.53 -283.173)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M221.53,359.205,574.751,336.25v1.923L221.53,361.125Z",
    transform: "translate(-221.53 -280.387)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M221.53,354.5,574.751,331.55v1.919L221.53,356.425Z",
    transform: "translate(-221.53 -277.606)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M221.53,349.8,574.751,326.85v1.919L221.53,351.721Z",
    transform: "translate(-221.53 -274.826)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M221.53,345.1,574.751,322.14v1.923L221.53,347.015Z",
    transform: "translate(-221.53 -272.039)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M221.53,340.391,574.751,317.44v1.919L221.53,342.315Z",
    transform: "translate(-221.53 -269.259)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M221.53,335.685,574.751,312.73v1.924L221.53,337.6Z",
    transform: "translate(-221.53 -266.472)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M221.53,330.981,574.751,308.03v1.919L221.53,332.9Z",
    transform: "translate(-221.53 -263.692)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M221.53,326.275,574.751,303.32v1.923L221.53,328.195Z",
    transform: "translate(-221.53 -260.905)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M221.53,321.571,574.751,298.62v1.919L221.53,323.495Z",
    transform: "translate(-221.53 -258.124)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M221.53,316.871,574.751,293.92v1.919L221.53,318.791Z",
    transform: "translate(-221.53 -255.344)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M221.53,312.161,574.751,289.21v1.924L221.53,314.085Z",
    transform: "translate(-221.53 -252.557)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M221.53,307.455,574.751,284.5v1.923L221.53,309.375Z",
    transform: "translate(-221.53 -249.771)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M221.53,302.751,574.751,279.8v1.919L221.53,304.675Z",
    transform: "translate(-221.53 -246.99)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M221.53,298.051,574.751,275.1v1.919L221.53,299.971Z",
    transform: "translate(-221.53 -244.21)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M221.53,293.345,574.751,270.39v1.923L221.53,295.265Z",
    transform: "translate(-221.53 -241.423)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M221.53,288.641,574.751,265.69v1.919L221.53,290.565Z",
    transform: "translate(-221.53 -238.643)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M221.53,283.935,574.751,260.98V262.9L221.53,285.855Z",
    transform: "translate(-221.53 -235.856)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M221.53,279.231,574.751,256.28V258.2L221.53,281.155Z",
    transform: "translate(-221.53 -233.076)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M221.53,274.525,574.751,251.57v1.923L221.53,276.445Z",
    transform: "translate(-221.53 -230.289)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M221.53,269.821,574.751,246.87v1.919L221.53,271.745Z",
    transform: "translate(-221.53 -227.508)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M221.53,265.115,574.751,242.16v1.923L221.53,267.035Z",
    transform: "translate(-221.53 -224.722)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M221.53,260.411,574.751,237.46v1.919L221.53,262.335Z",
    transform: "translate(-221.53 -221.941)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M221.53,255.705,574.751,232.75v1.923L221.53,257.625Z",
    transform: "translate(-221.53 -219.155)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M221.53,251,574.751,228.05v1.919L221.53,252.925Z",
    transform: "translate(-221.53 -216.374)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M221.53,246.3,574.751,223.35v1.919L221.53,248.221Z",
    transform: "translate(-221.53 -213.594)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M221.53,241.6,574.751,218.64v1.924L221.53,243.515Z",
    transform: "translate(-221.53 -210.807)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M221.53,236.891,574.751,213.94v1.919L221.53,238.815Z",
    transform: "translate(-221.53 -208.027)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M221.53,232.185,574.751,209.23v1.924L221.53,234.1Z",
    transform: "translate(-221.53 -205.24)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M221.53,227.481,574.751,204.53v1.919L221.53,229.4Z",
    transform: "translate(-221.53 -202.459)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M221.53,222.775,574.751,199.82v1.924L221.53,224.695Z",
    transform: "translate(-221.53 -199.673)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M221.53,220.639,547.483,199.46h27.268v.147L221.53,222.562Z",
    transform: "translate(-221.53 -199.46)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M221.53,218.719,517.916,199.46h29.567L221.53,220.639Z",
    transform: "translate(-221.53 -199.46)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M221.53,216.8,488.353,199.46h29.563L221.53,218.719Z",
    transform: "translate(-221.53 -199.46)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M221.53,214.877,458.786,199.46h29.567L221.53,216.8Z",
    transform: "translate(-221.53 -199.46)",
    fill: "#e4f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M458.786,199.46,221.53,214.877V199.46Z",
    transform: "translate(-221.53 -199.46)",
    fill: "#e4f1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M2135.133,1120.416h-5.979a.323.323,0,0,1-.327-.323.327.327,0,0,1,.327-.327h5.358l.086-1.809a.323.323,0,1,1,.645.028Zm-13.771,0h-7.792a.325.325,0,0,1,0-.649h7.792a.327.327,0,0,1,.327.327.323.323,0,0,1-.327.323Zm-15.584,0h-7.788a.323.323,0,0,1-.327-.323.327.327,0,0,1,.327-.327h7.788a.327.327,0,0,1,.327.327.323.323,0,0,1-.327.323Zm-15.58,0h-7.772a.323.323,0,0,1-.327-.323.327.327,0,0,1,.327-.327h7.759a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.327.327,0,0,1,.327.327.323.323,0,0,1-.327.323Zm-15.584,0h-7.792a.322.322,0,0,1-.323-.323.327.327,0,0,1,.323-.327h7.792a.327.327,0,0,1,.327.327.322.322,0,0,1-.327.323Zm-15.58,0h-7.792a.322.322,0,0,1-.327-.323.327.327,0,0,1,.327-.327h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.327.327,0,0,1,.327.327.323.323,0,0,1-.327.323Zm-15.584,0h-7.788a.323.323,0,0,1-.327-.323.327.327,0,0,1,.327-.327h7.788a.327.327,0,0,1,.327.327.323.323,0,0,1-.327.323Zm-15.58,0h-7.8a.323.323,0,0,1-.327-.323.327.327,0,0,1,.327-.327h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.327.327,0,0,1,.327.327.322.322,0,0,1-.327.323Zm-15.58,0h-7.792a.323.323,0,0,1-.327-.323.327.327,0,0,1,.327-.327h7.792a.327.327,0,0,1,.323.327.322.322,0,0,1-.323.323Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0H1911a.323.323,0,0,1-.323-.323.327.327,0,0,1,.323-.327h7.792a.327.327,0,0,1,.327.327.323.323,0,0,1-.327.323Zm-15.58,0h-7.792a.323.323,0,0,1-.327-.323.327.327,0,0,1,.327-.327h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.8a.327.327,0,0,1,.327.327.323.323,0,0,1-.327.323Zm-15.584,0h-7.792a.323.323,0,0,1-.323-.323.327.327,0,0,1,.323-.327h7.792a.327.327,0,0,1,.327.327.322.322,0,0,1-.327.323Zm-15.58,0h-7.792a.323.323,0,0,1-.327-.323.327.327,0,0,1,.327-.327h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-2l-.253-8.1a.327.327,0,1,1,.649,0l.233,7.473h1.368a.327.327,0,0,1,.327.327.322.322,0,0,1-.327.3Zm309.993-9.9h0a.322.322,0,0,1-.31-.339l.363-7.784a.314.314,0,0,1,.339-.306.323.323,0,0,1,.31.339l-.363,7.759a.323.323,0,0,1-.34.331Zm-312.162-5.672a.323.323,0,0,1-.323-.315l-.241-7.788a.327.327,0,0,1,.314-.335.335.335,0,0,1,.335.318l.241,7.784a.323.323,0,0,1-.314.335Zm312.885-9.891h0a.322.322,0,0,1-.306-.343l.359-7.759a.319.319,0,0,1,.339-.311.323.323,0,0,1,.31.339l-.363,7.784a.327.327,0,0,1-.34.29Zm-313.367-5.693a.323.323,0,0,1-.323-.314l-.241-7.788a.322.322,0,0,1,.314-.335.331.331,0,0,1,.335.314l.241,7.788a.331.331,0,0,1-.314.335Zm314.089-9.887h0a.322.322,0,0,1-.306-.339l.359-7.784a.319.319,0,0,1,.339-.306.323.323,0,0,1,.311.339l-.364,7.759a.323.323,0,0,1-.327.343Zm-314.571-5.689a.327.327,0,0,1-.327-.314l-.241-7.788a.327.327,0,1,1,.649,0l.241,7.788a.323.323,0,0,1-.314.335Zm315.274-9.875h0a.323.323,0,0,1-.311-.339l.364-7.759a.31.31,0,0,1,.339-.31.319.319,0,0,1,.306.339l-.359,7.784a.327.327,0,0,1-.318.3Zm-315.776-5.717a.327.327,0,0,1-.327-.314l-.241-7.788a.323.323,0,0,1,.314-.335.31.31,0,0,1,.335.314l.241,7.788a.327.327,0,0,1-.314.335Zm316.5-9.867h0a.323.323,0,0,1-.31-.339l.364-7.784a.318.318,0,0,1,.339-.31.327.327,0,0,1,.311.343l-.364,7.759a.323.323,0,0,1-.315.36Zm-316.989-5.717a.322.322,0,0,1-.323-.314l-.241-7.788a.323.323,0,0,1,.314-.335.319.319,0,0,1,.335.314l.241,7.788a.323.323,0,0,1-.314.335Zm317.724-9.858h0a.319.319,0,0,1-.306-.339l.359-7.784a.326.326,0,0,1,.565-.2.325.325,0,0,1,.084.234l-.364,7.784a.323.323,0,0,1-.327.343Zm-318.194-5.718a.323.323,0,0,1-.323-.314l-.241-7.788a.328.328,0,0,1,.549-.249.319.319,0,0,1,.1.229l.241,7.788a.322.322,0,0,1-.314.335Zm318.917-9.846h0a.319.319,0,0,1-.306-.339l.359-7.784a.326.326,0,0,1,.565-.206.322.322,0,0,1,.085.234l-.364,7.784a.322.322,0,0,1-.326.347Zm-319.4-5.717a.323.323,0,0,1-.323-.314l-.245-7.788a.327.327,0,0,1,.654,0l.241,7.788a.327.327,0,0,1-.315.335Zm320.121-9.838h0a.323.323,0,0,1-.311-.339l.364-7.784a.335.335,0,0,1,.339-.306.318.318,0,0,1,.306.339l-.359,7.784a.323.323,0,0,1-.327.331Zm-320.583-5.717a.331.331,0,0,1-.327-.319l-.241-7.784a.323.323,0,0,1,.314-.335.311.311,0,0,1,.335.315l.241,7.788a.323.323,0,0,1-.314.331Zm321.33-9.83h0a.327.327,0,0,1-.31-.339l.364-7.784a.323.323,0,1,1,.645.029l-.359,7.784a.322.322,0,0,1-.347.319Zm-321.808-5.746a.327.327,0,0,1-.323-.314l-.241-7.788a.327.327,0,1,1,.649,0l.241,7.788a.327.327,0,0,1-.314.335Zm322.539-9.8h0a.322.322,0,0,1-.31-.339l.363-7.784a.325.325,0,0,1,.649.033l-.364,7.759a.322.322,0,0,1-.355.315Zm-323.033-5.754a.323.323,0,0,1-.323-.315l-.241-7.788a.323.323,0,0,1,.314-.335.331.331,0,0,1,.335.314l.241,7.788a.327.327,0,0,1-.314.335Zm323.743-9.8h0a.323.323,0,0,1-.306-.339l.359-7.784a.33.33,0,0,1,.339-.31.323.323,0,0,1,.311.339l-.364,7.784a.327.327,0,0,1-.343.29ZM1818.3,949.11a.323.323,0,0,1-.323-.314l-.241-7.788a.323.323,0,0,1,.314-.335.318.318,0,0,1,.335.314l.224,7.784a.323.323,0,0,1-.314.335Zm324.948-9.8h0a.323.323,0,0,1-.31-.339l.363-7.784a.319.319,0,0,1,.339-.31.331.331,0,0,1,.306.343l-.364,7.759a.322.322,0,0,1-.339.31Zm-325.43-5.775a.327.327,0,0,1-.327-.315l-.241-7.788a.331.331,0,0,1,.314-.335.319.319,0,0,1,.335.314l.241,7.788a.323.323,0,0,1-.314.335Zm326.157-9.8h0a.323.323,0,0,1-.31-.339l.306-6.563h-.539a.327.327,0,0,1-.327-.327.323.323,0,0,1,.327-.323h1.225l-.335,7.245a.322.322,0,0,1-.351.294Zm-326.643-5.795a.327.327,0,0,1-.327-.314l-.045-1.454h7.008a.323.323,0,0,1,.323.323.327.327,0,0,1-.323.327h-6.338l.024.784a.323.323,0,0,1-.314.335Zm318.288-1.119h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.8a.327.327,0,0,1-.323-.327.323.323,0,0,1,.323-.323h7.792a.322.322,0,0,1,.326.323A.327.327,0,0,1,2120.035,916.819Zm-15.58,0h-7.792a.327.327,0,0,1-.326-.327.323.323,0,0,1,.326-.323h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0H2065.5a.327.327,0,0,1-.323-.327.322.322,0,0,1,.323-.323h7.792a.323.323,0,0,1,.327.323A.327.327,0,0,1,2073.287,916.819Zm-15.58,0h-7.792a.327.327,0,0,1-.327-.327.323.323,0,0,1,.327-.323h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.322.322,0,0,1,.326.323.326.326,0,0,1-.327.327Zm-15.58,0h-7.792a.327.327,0,0,1-.327-.327.323.323,0,0,1,.327-.323h7.792a.323.323,0,0,1,.323.323.327.327,0,0,1-.323.327Zm-15.584,0h-7.792a.327.327,0,0,1-.327-.327.323.323,0,0,1,.327-.323h7.792a.325.325,0,0,1,0,.649Zm-15.584,0H1972a.327.327,0,0,1-.323-.327.323.323,0,0,1,.323-.323h7.792a.323.323,0,0,1,.327.323.327.327,0,0,1-.327.327Zm-15.58,0h-7.792a.327.327,0,0,1-.327-.327.323.323,0,0,1,.327-.323h7.792a.323.323,0,0,1,.323.323.327.327,0,0,1-.323.327Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.322.322,0,0,1,.327.323.326.326,0,0,1-.327.327Zm-15.58,0h-7.784a.327.327,0,0,1-.327-.327.323.323,0,0,1,.327-.323h7.792a.325.325,0,1,1-.008.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0H1878.5a.325.325,0,0,1,0-.649h7.792a.323.323,0,0,1,.327.323.327.327,0,0,1-.327.327Zm-15.58,0h-7.792a.327.327,0,0,1-.327-.327.323.323,0,0,1,.327-.323h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.325.325,0,0,1,0,.649Zm-15.584,0h-7.792a.325.325,0,0,1,0-.649h7.792a.323.323,0,0,1,.327.323.327.327,0,0,1-.327.327Z",
    transform: "translate(-1713.74 -822.053)",
    fill: "#badef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M2179.864,984.338s4.615,46.748,2.63,62.654L2171.1,1167.76h98.38s-5.517-102.913-5.517-110.7-1.634-72.721-1.634-72.721l-15.42-7.792-38.8-.486Z",
    transform: "translate(-1923.255 -857.485)",
    fill: "#272f71"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(247.845 118.575)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M606.89,754.86l94.688,2H606.89Z",
    transform: "translate(-606.89 -565.161)",
    fill: "#a1d9d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M614.9,295.643l.114-5.293h94.978v7.3Z",
    transform: "translate(-611.629 -290.35)",
    fill: "#a1d9d8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M2229.615,977.85l-19.415,5.436s7.759,38.8,12.411,43.448-.784,8.119,3.108,12.015,25.487,33.165,25.487,33.165Z",
    transform: "translate(-1946.387 -858.544)",
    fill: "#5a6095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M2330.413,981l-19.8,92.793s21.052-37.208,22.87-39.009,0-9.417,0-12.987,11.186-34.635,11.186-34.635S2334.456,981,2330.413,981Z",
    transform: "translate(-2005.791 -860.408)",
    fill: "#5a6095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M2231.619,976.06l-20.779,2.111s7.514,38.213,12.15,42.852-.784,8.115,3.108,12.011,25.488,37.821,25.488,37.821Z",
    transform: "translate(-1946.765 -857.485)",
    fill: "#5a6095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M2329.437,977.25l-18.827,94.308s21.052-41.864,22.87-43.665,0-9.393,0-12.983,11.394-33.116,11.394-33.116S2333.463,977.25,2329.437,977.25Z",
    transform: "translate(-2005.791 -858.189)",
    fill: "#5a6095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M739.64,619.376,742.4,522.47l-.568,96.906Z",
    transform: "translate(-437.582 -309.101)",
    fill: "#5a6095"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 74.016,
    height: 7.792,
    transform: "translate(238.432 323.262)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M1964.37,978.827l-5.668-20.3-24.911,6.387s3.553,11.055,6.032,12.574l10.1,6.179h0l22.273,44.183,16.029-19.8Z",
    transform: "translate(-1782.859 -847.114)",
    fill: "#f99893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M2260.428,738.933s-18.475-4.974-27.055-2.287-26.545,15.927-26.635,46.576c0,0-3.524.592-5.146,5.052s-2.859,12.66,4.006,21.375,20.419,9.8,27.325,10.773,27.182-2.075,33.692-12.1S2260.428,738.933,2260.428,738.933Z",
    transform: "translate(-1940.544 -715.373)",
    fill: "#52626a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M2274.447,749.687c5.113.241,8.984,3.157,11.819,7.441,2.479,13.162,6.244,35.615,5.938,49.1a39.332,39.332,0,0,1-7.1,14.1q-.817,1-1.687,1.887c-7.408,4.292-17.667,6.064-23.809,6.069-18.377-5.191-21.191-23.245-18.01-42.26.858-5.121-.539-21.644,8.891-30.858C2256.82,748.972,2266.414,747.718,2274.447,749.687Z",
    transform: "translate(-1964.294 -723.052)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M2266.425,888.759s.976,13.146,0,19.153a24.8,24.8,0,0,1-4.7,10.549l19.966,94.794,18.827-94.308s-4.672-2.859-6-11.026-1.3-29.22-1.3-29.22Z",
    transform: "translate(-1976.867 -799.886)",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M2287.632,1099.1l14.657-73.411c-11.178,1.225-22.265-.188-30.519-1.887Z",
    transform: "translate(-1982.813 -885.729)",
    fill: "#007ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M2302.289,1025.693l-.315.033c-3.675,15-12.051,48.251-14.914,51.109-2.744,2.744-11.12-33.9-15.27-53.025h-.02l15.862,75.3Z",
    transform: "translate(-1982.813 -885.735)",
    fill: "#007ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M2299.456,901.318l-14.943-8.168-10.209,3.839q-.409.984-.764,2.07c.212,3.565.6,11.761,0,16.593l.086.233c.147.07.294.139.445.2C2286.677,921.382,2295.037,911.977,2299.456,901.318Z",
    transform: "translate(-1983.859 -808.435)",
    fill: "#f99893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M2274.146,755s-11.157-3.394-18.729,4.876-6.873,24.095-7.424,27.962-6.375,31.556,11.247,38.49,26.643-12.113,28.358-24.164S2289.211,758.676,2274.146,755Z",
    transform: "translate(-1967.942 -726.296)",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M1960.641,937.275c-.22-.274-18.659-17.822-22.306-16.744-6.069,1.581,7.416,11.643,8.874,13.53a20.335,20.335,0,0,1,1.948,3.267c-.478.135-.927.261-1.328.355-3.471.817-12.737,2.569-14.057,4.721,0,0-.249,12.137,2.94,12.207s6.412-1.1,9.834-.755a7.8,7.8,0,0,0,4.8-1.552c.212-.143.408-.286.6-.408a2.491,2.491,0,0,0-.106,2.5c1.633,3.32,12.942-2.409,13.436-4.529S1963.267,940.484,1960.641,937.275Zm-2.589,10.973a14.643,14.643,0,0,0-4.546,2.042c-.433-1.148-2.6-6.983-2.242-9.311h0c1.572-1.662,5.011-1.711,6.693-.992h0a1.6,1.6,0,0,1,.47.817C1958.963,943.021,1960.106,947.754,1958.052,948.248Z",
    transform: "translate(-1782.846 -824.605)",
    fill: "#ffc0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M1996.21,1027.821s26.3,67.526,36.346,72.717,46.964-50.971,46.964-50.971,1.425-53.237-3.12-53.237-23.229,22.224-28.587,35.595c-5.468,13.6-5.276,20.472-12.623,7.257-7.506-13.477-20.693-31.633-20.693-31.633C2006.9,1015.124,1996.21,1027.821,1996.21,1027.821Z",
    transform: "translate(-1819.787 -869.477)",
    fill: "#272f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M2281.21,736.751s6.534.114,9.96,3.716,11.733,6.26,13.354,30.592-2.79,26.492-2.79,26.492-6.848,10.173-1.225,19.5,19.48,8.078,27.6,4.75c11.815-4.839,13.031-27.288,10.5-42.448a43.191,43.191,0,0,0-1-5.162c-.976-3.467-.919-7.29-2.516-11.026-5.17-12.064-16.013-23.964-37.821-26.508C2297.288,736.669,2287.564,734.7,2281.21,736.751Z",
    transform: "translate(-1988.397 -715.355)",
    fill: "#52626a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M2368.412,804.419c.776,4.264.666,3.639,1.225,7.024.122.719.233,1.458.335,2.205-3.925-3.075-4.668-3.876-9.193-7.065a149.308,149.308,0,0,0-26.77-14.914c-.123-.555-.249-1.09-.38-1.609C2346.008,793.009,2358.141,797.052,2368.412,804.419Z",
    transform: "translate(-2019.41 -747.445)",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M1885.416,877.274a1.225,1.225,0,0,1-1-1.911l46.262-67.028a1.225,1.225,0,1,1,2.009,1.384l-46.266,67.028a1.225,1.225,0,0,1-1,.527Z",
    transform: "translate(-1753.524 -757.886)",
    fill: "#28a349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M1691.088,1062.313a1.2,1.2,0,0,1-.817-.327,1.225,1.225,0,0,1-.061-1.723l76.776-82.085a1.225,1.225,0,1,1,1.764,1.67l-76.776,82.085a1.226,1.226,0,0,1-.886.38Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, -1564.197, -983.601)",
    fill: "#28a349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M1789.722,916.391a1.225,1.225,0,0,1-.711-.229l-61.752-44.285a1.225,1.225,0,0,1,1.421-1.985l61.752,44.265a1.225,1.225,0,0,1-.71,2.209Z",
    transform: "translate(-1660.419 -794.574)",
    fill: "#28a349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M1912.028,1082.157a1.209,1.209,0,0,1-1.184-.683L1877.9,979.241c-.086-.454.321-.88.937-.984a1.342,1.342,0,0,1,1.44.585l32.936,102.234c.148.474-.258.945-.911,1.058A1.462,1.462,0,0,1,1912.028,1082.157Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, -1502.177, -1223.37)",
    fill: "#28a349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M1912.028,1085.757a1.2,1.2,0,0,1-1.184-.706L1877.9,979.276c-.086-.47.321-.911.937-1.018a1.324,1.324,0,0,1,1.44.6l32.936,105.775c.148.49-.258.978-.911,1.095A1.424,1.424,0,0,1,1912.028,1085.757Z",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, -1895.674, 721.444)",
    fill: "#28a349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M1874.677,961.139a13.714,13.714,0,1,1-13.712-13.71,13.714,13.714,0,0,1,13.712,13.71Z",
    transform: "translate(-1731.66 -840.547)",
    fill: "#4ab169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M1876.909,966.649a8.739,8.739,0,1,1-8.74-8.74A8.74,8.74,0,0,1,1876.909,966.649Z",
    transform: "translate(-1738.866 -846.747)",
    fill: "#28a349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M12.58,0h46a12.58,12.58,0,0,1,12.58,12.58V49.27a12.58,12.58,0,0,1-12.58,12.58h-46A12.58,12.58,0,0,1,0,49.27V12.58A12.58,12.58,0,0,1,12.58,0Z",
    transform: "translate(-0.293 45.054)",
    fill: "#5ab275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M12.58,0h46a12.58,12.58,0,0,1,12.58,12.58V49.27a12.58,12.58,0,0,1-12.58,12.58h-46A12.58,12.58,0,0,1,0,49.27V12.58A12.58,12.58,0,0,1,12.58,0Z",
    transform: "translate(-0.293 167.054)",
    fill: "#5ab275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 81.187,
    height: 61.85,
    rx: 16.6,
    transform: "translate(215.894 61.904) rotate(180)",
    fill: "#5ab275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M13.438,0H67.749A13.438,13.438,0,0,1,81.187,13.438V48.412A13.438,13.438,0,0,1,67.749,61.85H13.438A13.438,13.438,0,0,1,0,48.412V13.438A13.438,13.438,0,0,1,13.438,0Z",
    transform: "translate(183.894 281.904) rotate(180)",
    fill: "#5ab275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M13.438,0H67.749A13.438,13.438,0,0,1,81.187,13.438V48.412A13.438,13.438,0,0,1,67.749,61.85H13.438A13.438,13.438,0,0,1,0,48.412V13.438A13.438,13.438,0,0,1,13.438,0Z",
    transform: "translate(279.68 196.252) rotate(180)",
    fill: "#5ab275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M2392.427,996.09s-3.345,37.106,1.707,65.366c1.27,7.1,20.872,10.25,31.584,18.316,17.85,13.44,30.294,31.58,33.467,38.8,7.237-3.267,7.2-35.856,3.234-48.8C2458.112,1061.158,2392.427,996.09,2392.427,996.09Z",
    transform: "translate(-2053.553 -869.335)",
    fill: "#272f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M922.374,412.771l-69.058-8.352L810.06,486.836h56.006Z",
    transform: "translate(-479.243 -239.261)",
    fill: "#007ab3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(372.848 165.159)",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M2491.165,1172.546l56.308-74.065-69.058-8.351-1.225,2.352c10.8,2.826,31.683,9.45,34.786,19.043,3.312,10.242-20.795,46.148-31.241,61.021Z",
    transform: "translate(-2477.19 -1090.13)",
    fill: "#007ab3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M846,395.24,801.98,479.931l3.3,1.474,43.256-82.416,69.058,8.352-4.206-3.3Z",
    transform: "translate(-474.463 -233.83)",
    fill: "#009de6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M2440.071,1220.036c1.258-1,11.774,5.53,17.814,9.438l.037-.245c-5.685-4.219-15.637-9.25-13.358-10.7,1.164-.743,26.137,9.319,26.137,9.323,2.63,1.188,2.749,1.3,5.464,2.5-.645-1.568-7.179-12.207-2.769-11.684l14.588,19.076c2.475,4.055,2.389,6.514,1.772,8.633-.756,2.6-4.415,9.585-10.377,10.99-5.738,1.352-21.305-7.441-23.739-9.715-2.618-2.254-20.464-17.851-17.614-22.2,0,0,14.877,14.522,16.458,12.721.094-.408-14.7-10.246-15.87-14.085-.817-2.748,12.117,5.632,17.785,9.834C2451.31,1229.76,2439.205,1220.743,2440.071,1220.036Z",
    transform: "translate(-2080.99 -1000.913)",
    fill: "#ffc0bb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_180_",
    transform: "translate(197 496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_185_",
    d: "M40.742,173.6v6.434H9.647V173.6H6v14.634H9.647v-4.561h31.1v4.561h3.647V173.6Z",
    transform: "translate(-6 -171.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_184_",
    d: "M66.682,212.766h4.146a1.183,1.183,0,0,0,1.182-1.182h0a1.185,1.185,0,0,0-.975-1.167l-4.146-.745a1.184,1.184,0,0,0-1.39,1.167v.745A1.183,1.183,0,0,0,66.682,212.766Z",
    transform: "translate(-60.932 -204.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_183_",
    d: "M159.305,181.328h16.638c.545-.031.983-.66.983-1.443v-2.841c0-.8-.461-1.443-1.029-1.443s-1.013.668-1.013,1.459v1.382h-8.83v-.814c0-.837-.484-1.52-1.075-1.52h-5.674c-.722,0-1.305.822-1.305,1.843v1.543C158,180.506,158.584,181.328,159.305,181.328Z",
    transform: "translate(-146.33 -173.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_182_",
    cx: 1.42,
    cy: 1.72,
    rx: 1.42,
    ry: 1.72,
    transform: "translate(10.798 2.466) rotate(99.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_181_",
    d: "M9.647,148.053a.256.256,0,0,0-.253-.253H6.253a.256.256,0,0,0-.253.253v1.328H9.647Z",
    transform: "translate(-6 -147.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_6588580_and_baby_diaper_nappies_toys_icon",
    "data-name": "6588580_and_baby_diaper_nappies_toys_icon",
    d: "M35.25,18.25a1.5,1.5,0,0,1-1.583-1.583v-4.75a1.5,1.5,0,0,1,1.583-1.583H46.175A7.964,7.964,0,0,0,38.417,4H9.917a7.964,7.964,0,0,0-7.758,6.333H13.083a1.5,1.5,0,0,1,1.583,1.583v4.75a1.5,1.5,0,0,1-1.583,1.583H2v1.583A22.091,22.091,0,0,0,18.467,41.208c.158,0,.317.158.475.158A18.91,18.91,0,0,0,24.167,42a29.465,29.465,0,0,0,5.383-.633h.317A22.091,22.091,0,0,0,46.333,19.992V18.408H35.25ZM5.642,23.792a22.18,22.18,0,0,1,11.4,13.617A18.756,18.756,0,0,1,5.642,23.792ZM31.45,37.408a22.18,22.18,0,0,1,11.4-13.617A19.458,19.458,0,0,1,31.45,37.408Z",
    transform: "translate(300 656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(336 463)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H37a4,4,0,0,1,4,4V7a0,0,0,0,1,0,0H0A0,0,0,0,1,0,7V4A4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,.5H37A3.5,3.5,0,0,1,40.5,4V6a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,6V4A3.5,3.5,0,0,1,4,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(350 436)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    rx: 6.5,
    ry: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6,
    rx: 6,
    ry: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(346 447)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 17,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 16,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    transform: "translate(351 453)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 1,
    height: 7,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1M1,0v7M1,6h-1M0,7v-7",
    fill: "none",
    clipPath: "url(#clip)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    transform: "translate(361 453)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-2",
    width: 1,
    height: 7,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1M1,0v7M1,6h-1M0,7v-7",
    fill: "none",
    clipPath: "url(#clip-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(340 469)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(350 458)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 21,
    rx: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 20,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(356 458)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 21,
    rx: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 20,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    transform: "translate(356 451)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 4,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    transform: "translate(336 479)",
    fill: "#fff",
    stroke: "#404040",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-3",
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h0.000010000005204346962M1,0v5M0.000010000005204346962,4h-0.000010000005204346962M-0.9999899999947957,5v-5",
    fill: "none",
    clipPath: "url(#clip-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    transform: "translate(375 475)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-4",
    width: 1,
    height: 4,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1M1,0v4M1,3h-1M0,4v-4",
    fill: "none",
    clipPath: "url(#clip-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    transform: "translate(340 475)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-5",
    width: 1,
    height: 4,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1M1,0v4M1,3h-1M0,4v-4",
    fill: "none",
    clipPath: "url(#clip-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    transform: "translate(354.311 453.391) rotate(-90)",
    fill: "#fff",
    stroke: "#28a349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-6",
    width: 0.595,
    height: 4.466,
    rx: 0.298,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5h0.5954676270484924M0.5,0v4.466007232666016M0.5954676270484924,3.9660072326660156h-0.5954676270484924M0.09546762704849243,4.466007232666016v-4.466007232666016",
    fill: "none",
    clipPath: "url(#clip-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1941",
    transform: "translate(200 614.288) rotate(-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1943",
    d: "M8.174,0C6.451.193.187,3.056,0,17.819-.188,33.37,6.451,36.642,8.192,36.607V26.335c-1.433,0-1.722-1.561-2.049-4.781a36.661,36.661,0,0,1,0-7.39c.2-1.84.539-3.635,2.04-3.635Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1945",
    d: "M119.538,352.3a1.139,1.139,0,0,0,1.14-1.147l0,0s0-8.006,0-8.011a1.136,1.136,0,0,0-1.14-1.136h-2.91v10.3s2.9,0,2.905,0Z",
    transform: "translate(-107.65 -315.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1947",
    d: "M119.538,10.529a1.139,1.139,0,0,0,1.14-1.147l0,0s0-8.237,0-8.242A1.136,1.136,0,0,0,119.538,0h-2.91V10.529s2.9,0,2.905,0Z",
    transform: "translate(-107.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pills-pill-svgrepo-com",
    transform: "translate(398.786 560.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380",
    transform: "translate(17.748 29.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M229.213,215.054a11.238,11.238,0,0,0-.875,14.91l15.784-15.784A11.238,11.238,0,0,0,229.213,215.054Z",
    transform: "translate(-225.921 -211.764)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382",
    transform: "translate(22.022 33.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M296.1,266.161l-15.784,15.784A11.238,11.238,0,0,0,296.1,266.161Z",
    transform: "translate(-280.319 -266.161)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    transform: "translate(6.115 14.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M94.348,15.087A9.967,9.967,0,0,0,81.1,19.9l-3.254,6.971,11.9,5.557a14.01,14.01,0,0,1,1.166-1.322,13.821,13.821,0,0,1,8.731-4.018A9.968,9.968,0,0,0,94.348,15.087Zm-2.671,5.721a3.658,3.658,0,0,0-4.856,1.765l-2.379-1.111a6.286,6.286,0,0,1,8.346-3.033Z",
    transform: "translate(-77.846 -14.149)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386",
    transform: "translate(0 29.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M16.138,223.267a13.9,13.9,0,0,1,0-10.431q.213-.525.467-1.027L5,206.393.938,215.1a9.968,9.968,0,0,0,16.575,10.733A13.753,13.753,0,0,1,16.138,223.267Z",
    transform: "translate(0 -206.393)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignImage);
export default __webpack_public_path__ + "static/media/sign-image.3b1fd4e8afc1148ab78b00b9e720972a.svg";
export { ForwardRef as ReactComponent };